export const serialize = (obj: any) => {
	const str = [];
	for (const p in obj)
		if (obj.hasOwnProperty(p) && obj[p]) {
			str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
		}
	return str.join('&');
};

export const isMobile = () => {
	return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export const updateQueryStringParameter = (uri: string, key: string, value: string) => {
	const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
	const separator = uri.indexOf('?') !== -1 ? '&' : '?';

	if (uri.match(re)) {
		return uri.replace(re, `$1${key}=${value}$2`);
	}

	return `${uri}${separator}${key}=${value}`;
};

export const getPublicationFileName = (s3Key: string) => s3Key.split('/').pop() || 'Unknown';
